import { render, staticRenderFns } from "./ChangeEmailComponent.vue?vue&type=template&id=439105c2"
import script from "./ChangeEmailComponent.vue?vue&type=script&lang=js"
export * from "./ChangeEmailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports